/** Persistance session des filtres / tri / pagination du screener (retour depuis fiche titre). */

export const SCREENER_STATE_KEY = "invelps.screener.state";

export function loadScreenerState() {
  if (typeof window === "undefined") return null;
  try {
    const raw = window.sessionStorage.getItem(SCREENER_STATE_KEY);
    if (!raw) return null;
    const parsed = JSON.parse(raw);
    return parsed && typeof parsed === "object" ? parsed : null;
  } catch {
    return null;
  }
}

export function saveScreenerState(state) {
  if (typeof window === "undefined" || !state) return;
  try {
    window.sessionStorage.setItem(SCREENER_STATE_KEY, JSON.stringify(state));
  } catch {
    /* quota / private mode */
  }
}

export function clearScreenerState() {
  if (typeof window === "undefined") return;
  try {
    window.sessionStorage.removeItem(SCREENER_STATE_KEY);
  } catch {
    /* ignore */
  }
}

/** Fusionne filtres sauvegardés avec les défauts courants (nouveaux champs ETL). */
export function mergeScreenerFilterValues(savedFv, defaultFv) {
  if (!defaultFv || typeof defaultFv !== "object") return savedFv || {};
  const out = { ...defaultFv };
  if (!savedFv || typeof savedFv !== "object") return out;
  for (const key of Object.keys(defaultFv)) {
    if (Object.prototype.hasOwnProperty.call(savedFv, key)) {
      out[key] = savedFv[key];
    }
  }
  return out;
}
